import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  slideContainer: {
    paddingBottom: theme.spacing(4),
  },
}));

export default useStyles;
